import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=4842c94a"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4842c94a')) {
      api.createRecord('4842c94a', component.options)
    } else {
      api.reload('4842c94a', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=4842c94a", function () {
      api.rerender('4842c94a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/statement_account_global/Index.vue"
export default component.exports